/* eslint-disable */
class NLForms {
	constructor() {
		this.init();
	}

	init() {}

	newForm(form) {
		this.formPrivacyPolicy = form.querySelector("#newsletter-input-form");
		if (!this.formPrivacyPolicy) {
			this.formPrivacyPolicy = form.querySelector("#privacy-input-form");
		}
		this.formNewsLetter = form.querySelector("#newsletter_subscription");
		this.formMagazine = form.querySelector("#magazine_subscription");
		this.formSendButton = form.querySelector(".contact-button");

		// Make sure the privacy policy value is unchecked
		this.formPrivacyPolicy.checked = false;
		this.formPrivacyPolicy.value = "unchecked";

		this.formNewsLetter.checked = false;
		this.formNewsLetter.value = "unchecked";
		this.formMagazine.checked = false;
		this.formMagazine.value = "unchecked";

		// Listen for privacy policy checkbox changes
		this.formPrivacyPolicy.addEventListener("change", this.checkboxToogle);

		this.formNewsLetter.addEventListener("change", this.checkboxToogle);
		this.formMagazine.addEventListener("change", this.checkboxToogle);

		// Prevent form submit
		form.addEventListener("submit", this.preventFormSubmit);

		// Form validations and submit
		this.formSendButton.addEventListener("click", this.submitValidateForm);

		// Enable submit button
		this.formSendButton.disabled = false;
	}

	checkboxToogle(checkbox) {
		if (checkbox.srcElement.value === "unchecked") {
			checkbox.srcElement.value = "checked";
		} else {
			checkbox.srcElement.value = "unchecked";
		}
	}

	preventFormSubmit(evt) {
		evt.preventDefault();
	}

	submitValidateForm(evt) {
		// Get the form parameters
		const action = this.form.dataset.action;
		const email = this.form.querySelectorAll("[name=email]")[0];
		const privacyPolicy = this.form.querySelectorAll(
			"[name=privacy_policy]"
		)[0];
		const receiverEmail = this.form.querySelectorAll(
			"[name=receiver_email]"
		)[0];

		const successMessage = document.querySelectorAll(
			'[name="success_message"]'
		);
		const errorMessage = this.form.querySelectorAll("[name=error_message]");
		const validationMessage = document.querySelectorAll(
			'[name="validation_message"]'
		);

		let firstName = false;
		let newsletterSubscription = false;
		let magazineSubscription = false;

		if ("newsletter_form" == action) {
			firstName = this.form.querySelectorAll("[name=first_name]")[0];
			newsletterSubscription = this.form.querySelectorAll(
				"[name=newsletter_subscription]"
			)[0];
			magazineSubscription = this.form.querySelectorAll(
				"[name=magazine_subscription]"
			)[0];
		}
		const formData = new FormData();
		formData.append("action", action);

		if (email) {
			formData.append("email", email.value);
		}

		if (privacyPolicy) {
			formData.append("privacy_policy", privacyPolicy.value);
		}

		if ("newsletter_form" == action) {
			if (receiverEmail) {
				formData.append("receiver_email", receiverEmail.value);
			}

			if (firstName) {
				formData.append("first_name", firstName.value);
			}

			if (newsletterSubscription.checked) {
				formData.append(
					"newsletter_subscription",
					newsletterSubscription.value
				);
			}

			if (magazineSubscription.checked) {
				formData.append("magazine_subscription", magazineSubscription.value);
			}
		}

		// Disable and animate the submit button
		evt.srcElement.disabled = true;
		evt.srcElement.classList.add("validating");

		// Ajax form submit
		const xmlhttp = window.ajaxReq();
		const url = encodeURI(scriptsAjaxVariables.ajax_url); // eslint-disable-line
		xmlhttp.open("POST", url, true); // set true for async, false for sync request
		xmlhttp.send(formData); // or null, if no parameters are passed

		// Validation
		xmlhttp.onreadystatechange = () => {
			if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
				try {
					const data = JSON.parse(xmlhttp.responseText);

					// Hide previous errors
					if ("newsletter_form" == action) {
						if (firstName) {
							firstName.classList.remove("show-error");
						}
					}
					if (email) {
						email.classList.remove("show-error");
					}
					if (privacyPolicy) {
						privacyPolicy.classList.remove("show-error");
					}
					if (data.validation === false) {
						// Show errors
						if (data.email) {
							email.classList.add("show-error");
						}
						if (data.privacy_policy) {
							privacyPolicy.classList.add("show-error");
						}
						if ("newsletter_form" == action) {
							if (data.first_name) {
								firstName.classList.add("show-error");
							}
						}

						// Scroll to the first error.
						const elementsWithError =
							evt.srcElement.form.getElementsByClassName("show-error");
						elementsWithError[0].scrollIntoView({
							block: "center",
							behavior: "smooth",
						});
					} else if (data.success === false) {
						// Error notification message
						successMessage[0].style.display = "none";
						errorMessage[0].style.display = "flex";
						validationMessage[0].style.display = "none";
					} else {
						// Success notification message
						successMessage[0].style.display = "flex";
						errorMessage[0].style.display = "none";
						validationMessage[0].style.display = "none";

						setTimeout(() => {
							const newsletterPopup =
								document.getElementById("newsletter-modal");
							// Close newsletter form popup
							newsletterPopup.classList.remove("active");
						}, 1000);

						// Clear the form
						evt.srcElement.form.reset();
					}

					// Enable and stop the submit button animation
					evt.srcElement.disabled = false;
					evt.srcElement.classList.remove("validating");
				} catch (error) {
					// Show notification
					console.log(error);
				}
			}
		};
	}
}

export default NLForms;
